"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Craftsmanship() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: p1Ref,
    isVisible: p1Visible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: ruleRef,
    isVisible: ruleVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="19397" id="digital-craftsmanship" className="bg-background text-foreground py-32 md:py-48">
      <div className="mx-auto w-full max-w-[1440px] px-5 md:px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-6">
          {}
          <div ref={titleRef} className="md:col-span-4" style={{
          opacity: titleVisible ? 1 : 0,
          transform: titleVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 500ms cubic-bezier(0.2, 0.7, 0.2, 1), transform 500ms cubic-bezier(0.2, 0.7, 0.2, 1)"
        }}>
            <p className="font-default text-xs font-bold uppercase tracking-[0.2em] text-primary">
              Operational Standards
            </p>
            <h2 className="font-default mt-6 text-[clamp(1.875rem,2.8vw,2.75rem)] font-medium leading-[1.05] tracking-[-0.02em] text-foreground">
              Our commitment to digital craftsmanship.
            </h2>
            <div className="mt-6 h-px w-full overflow-hidden bg-transparent">
              <div className="h-px bg-foreground" style={{
              width: titleVisible ? "100%" : "0%",
              transition: "width 600ms ease-out 200ms"
            }} />
            </div>
          </div>

          {}
          <div className="md:col-span-8 md:col-start-5">
            <div className="space-y-8">
              <p ref={p1Ref} className="font-default text-foreground" style={{
              opacity: p1Visible ? 1 : 0,
              transform: p1Visible ? "translateY(0)" : "translateY(16px)",
              transition: "opacity 500ms cubic-bezier(0.2, 0.7, 0.2, 1), transform 500ms cubic-bezier(0.2, 0.7, 0.2, 1)"
            }}>
                <span className="font-default block text-[1.25rem] font-medium leading-[1.55] tracking-[0]">
                  At CSOS, we bridge the gap between old‑school grit and modern digital power. We help independent contractors and tradespeople level up their businesses without losing the human touch.
                </span>
                <span className="mt-4 block text-[clamp(1rem,1.1vw,1.125rem)] font-normal leading-[1.55] tracking-[0] text-foreground">
                  We don’t manage your labor or dispatch your crews—we design and deploy the bespoke operational frameworks that allow you to thrive. Every system build is treated like custom craftsmanship, tailored exactly to how you run your business.
                </span>
              </p>
            </div>

            {}
            <div ref={ruleRef} className="mt-16 h-px w-full overflow-hidden">
              <div className="h-px bg-border" style={{
              width: ruleVisible ? "100%" : "0%",
              transition: "width 600ms ease-out"
            }} />
            </div>

          </div>
        </div>
      </div>
    </section>;
}